/**
 * 受注紐付け一覧
 */
import Vue from 'vue'
import * as httpConst from '../../../../constants/httpConst'

const driver_schedule_association_order = {
  namespaced: true,
  actions: {
    /**
     * ドライバースケジュール
     * 受注紐付け一覧
     * @param commit
     * @param conditions
     * @returns {Promise<unknown>}
     */
    index ({ commit }, { conditions }) {
      return new Promise((resolve) => {
        Vue.$http.get(`${httpConst.DRIVER_ENDPOINT}/driver_schedules/association_orders`, { params: conditions }).then(data => {
          resolve(data.content)
        })
      })
    },
    create ({ commit }, { params }) {
      return new Promise((resolve) => {
        Vue.$http.post(`${httpConst.DRIVER_ENDPOINT}/driver_schedules/association_orders`, params).then(data => {
          commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
          resolve(data.content)
        })
      })
    },
  },
}
export default driver_schedule_association_order
